import { Utilities as utilities } from "@truckdown/framework";
import { ThrottleLimits } from "./ThrottleLimits";

export class Throttle {
    constructor(json?: any) {
        if (json) {
            this.id = utilities.json.getStringValue(json, "id", utilities.data.newObjectId());
            this.name = utilities.json.getStringValue(json, "n", '');
            this.description = utilities.json.getStringValue(json, "d");
            this.enableCaptchaOnFirstRequest = utilities.json.getBooleanValue(json, "enableCaptchaOnFirstRequest", false);
            if (json.ip) {
                this.ipLimits = utilities.json
                    .getObjectValue(json, (itm) => { return new ThrottleLimits(itm); }, 'ip')
                    ?? undefined;
            }
            if (json.user) {
                this.userLimits = utilities.json.getObjectValue(json, (itm) => { return new ThrottleLimits(itm); }, 'user')
                    ?? undefined;
            }
            if (json.ace) {
                this.aceLimits = utilities.json.getObjectValue(json, (itm) => { return new ThrottleLimits(itm); }, 'ace')
                    ?? undefined;
            }
            if (json.api) {
                this.apiLimits = utilities.json.getObjectValue(json, (itm) => { return new ThrottleLimits(itm); }, 'api')
                    ?? undefined;
            }
        }
    }

    toJSON() {
        return {
            id: this.id,
            n: this.name,
            d: this.description,
            ip: this.ipLimits,
            user: this.userLimits,
            ace: this.aceLimits,
            api: this.apiLimits,
            enableCaptchaOnFirstRequest: this.enableCaptchaOnFirstRequest
        };
    }

    id: string = utilities.data.newObjectId();
    name: string = '';
    description: string | null = null;
    ipLimits?: ThrottleLimits;
    userLimits?: ThrottleLimits;
    aceLimits?: ThrottleLimits;
    apiLimits?: ThrottleLimits;
    enableCaptchaOnFirstRequest: boolean = false;
}